var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "setting-page tongxin-layout"
  }, [_c('h1', {
    staticClass: "title-with-underline"
  }, [_vm._v("資料設定")]), _c('div', {
    staticClass: "setting-buttons"
  }, [_c('b-button', {
    staticClass: "btn-rounded",
    attrs: {
      "block": "",
      "variant": _vm.selectedAction === 'switchClinic' ? 'primary' : 'outline-secondary'
    },
    on: {
      "click": function click($event) {
        _vm.selectedAction = 'switchClinic';
      }
    }
  }, [_vm._v(" 切換院所 ")]), _c('b-button', {
    staticClass: "btn-rounded",
    class: {
      disabled: !_vm.hasRegistered
    },
    attrs: {
      "block": "",
      "variant": _vm.selectedAction === 'familyList' ? 'primary' : 'outline-secondary'
    },
    on: {
      "click": function click($event) {
        _vm.selectedAction = _vm.hasRegistered ? 'familyList' : _vm.selectedAction;
      }
    }
  }, [_vm._v(" 編輯家庭成員資料 ")]), _c('b-button', {
    staticClass: "btn-rounded",
    class: {
      disabled: !_vm.hasRegistered
    },
    attrs: {
      "block": "",
      "variant": _vm.selectedAction === 'rebindPhone' ? 'primary' : 'outline-secondary'
    },
    on: {
      "click": function click($event) {
        _vm.selectedAction = _vm.hasRegistered ? 'rebindPhone' : _vm.selectedAction;
      }
    }
  }, [_vm._v(" 重新綁定手機 ")])], 1), _c('div', {
    staticClass: "setting-nav"
  }, [_c('TongxinNavigation', {
    attrs: {
      "canProceed": _vm.selectedAction !== null,
      "backButtonIsVisible": true,
      "nextButtonIsVisible": true,
      "textForNextStep": "下一步"
    },
    on: {
      "back": _vm.handleBack,
      "next": _vm.handleNext
    }
  })], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }